module.exports = __webpack_public_path__ + "img/162.6705ed45.jpg";